import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbsComponent } from 'components/breadcrumbs/breadcrumbs.component';
import { RoleComponent } from 'components/role/role.component';
import { SpinnerComponent } from 'components/spinner/spinner.component';
import { ApiService } from 'services/api.service';
import { Breadcrumb } from 'types/breadcrumb.interface';
import {
  RoleListItem,
  RoleListItemPagedResponse,
  StructuralUnitRoleListItem,
  StructuralUnitRoleListItemPagedResponse
} from 'types/role.interface';
import { CLAIM_SCOPES, CLAIM_TYPES } from 'types/user.interface';
import { checkClaims } from 'util/user.utility';

@Component({
  selector: 'app-role-page',
  standalone: true,
  imports: [SpinnerComponent, BreadcrumbsComponent, TranslateModule, RoleComponent],
  templateUrl: './role-page.component.html',
  styleUrl: './role-page.component.scss'
})
export class RolePageComponent implements OnInit {
  public readonly CLAIM_SCOPE = CLAIM_SCOPES['role'];
  public readonly CLAIM_TYPES = CLAIM_TYPES;
  public readonly checkClaims = checkClaims;
  breadcrumbs: Breadcrumb[] = [
    {
      title: 'components.breadcrumbs.admin',
      url: ''
    },
    {
      title: 'components.breadcrumbs.roles',
      url: '/lomas'
    }
  ];
  systemRoles: RoleListItem[] = [];
  structuralUnitRoles: StructuralUnitRoleListItem[] = [];
  isSystemRolesLoading: boolean = true;
  isStructuralUnitRolesLoading: boolean = true;

  get isLoading(): boolean {
    return this.isSystemRolesLoading || this.isStructuralUnitRolesLoading;
  }

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.apiService.getSystemRoles().subscribe(
      (data: RoleListItemPagedResponse) => {
        this.systemRoles = data.list ?? [];
        this.systemRoles.sort((a: RoleListItem, b: RoleListItem) => a.name!.localeCompare(b.name!));
        this.isSystemRolesLoading = false;
      },
      (error: any) => {
        console.error(error);
      }
    );

    this.apiService.getStructuralUnitRoles().subscribe(
      (data: StructuralUnitRoleListItemPagedResponse) => {
        this.structuralUnitRoles = data.list ?? [];
        this.structuralUnitRoles.sort((a: StructuralUnitRoleListItem, b: StructuralUnitRoleListItem) => a.name!.localeCompare(b.name!));
        this.isStructuralUnitRolesLoading = false;
      },
      (error: any) => {
        console.error(error);
      }
    );
  }
}
